import { useRoleStore } from '@/stores/role';
import { useAuthStore } from '@/stores/auth';
import { useFeaturesStore } from '@/stores/features';
import { ROLES } from '@/data/roles';
import { BrandHomeLink } from '@/design-system/brand/BrandHomeLink';
import { NavItem } from '@/components/molecules/NavItem';
import { UserCard } from '@/components/molecules/UserCard';
import { RoleSeg } from '@/components/molecules/RoleSeg';
import { BETA_MODE, isBetaNavigationRoute, isBetaRouteAllowedForRole } from '@/app/BetaRouteGate';

export const Sidebar = () => {
  const previewRole = useRoleStore((s) => s.role);
  const user = useAuthStore((s) => s.user);
  const flags = useFeaturesStore((s) => s.flags);
  const showRoleSwitcher = flags.roleSwitcher;
  const role = showRoleSwitcher ? previewRole : (user?.role ?? previewRole);
  const def = ROLES[role];
  const initials = user?.name
    ? user.name.split(/\s+/).slice(0, 2).map((part) => part[0]).join('').toUpperCase()
    : def.identity.avatar;
  const identityName = user?.name ?? def.identity.name;
  const identityMeta = user?.email ?? def.identity.meta;

  return (
    <aside className="sidebar" id="sidebar">
      <div className="brand-row">
        <BrandHomeLink size={18} />
        <span className="tag">{def.label}</span>
      </div>

      {def.nav.map((group, gi) => (
        <div key={gi} className="nav-group">
          {group.label && <div className="grouplabel">{group.label}</div>}
          {group.items
            .filter((item) => (!item.feature || flags[item.feature] || (BETA_MODE && isBetaNavigationRoute(item.route))))
            .filter((item) => !BETA_MODE || isBetaRouteAllowedForRole(item.route, role))
            .filter((item) => !item.associationRoles || item.associationRoles.includes(user?.association_role ?? 'staff'))
            .map((item) => (
              <NavItem
                key={item.id}
                to={item.route}
                label={item.label}
                icon={item.icon}
                count={BETA_MODE ? undefined : item.count}
                alert={BETA_MODE ? false : item.alert}
                end={item.route === '/'}
              />
            ))}
        </div>
      ))}

      <UserCard
        name={identityName}
        meta={identityMeta}
        avatar={initials}
        bg={def.identity.bg}
      />

      {showRoleSwitcher && <RoleSeg />}
    </aside>
  );
};
